import { Linking, Platform } from 'react-native'
import Config from 'react-native-config'
import Bugsnag from '@src/config/bugsnag'

const redirect = (storeLink: string | undefined) => {
  if (!storeLink) {
    Bugsnag.notify('Store link is undefined')
    return
  }
  Linking.openURL(storeLink)
}

const buildStoreLink = ({ appStoreQueryParams }: { appStoreQueryParams?: string } = {}) => {
  return Platform.select({
    ios: `${Config.APP_STORE_LINK}${appStoreQueryParams ? `?${appStoreQueryParams}` : ''}`,
    android: Config.GOOGLE_PLAY_LINK,
    web: Config.WEBSITE_BASE_URL,
  })
}

export const redirectToWriteReview = () => {
  const storeLink = buildStoreLink({ appStoreQueryParams: 'action=write-review' })
  redirect(storeLink)
}

export const redirectToAppPage = () => {
  redirect(buildStoreLink())
}
